import React from 'react'
import {render} from 'react-dom'
import App from './App'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'


//Main navigation
import Home from "./Home";

import Buyer from "./Buyer";
import Seller from "./Seller";
import Escrow from "./Escrow";
import Help from "./Help";
import Search from "./Search";


//Main navigation if no node connection


//Home Nav

import ViewAddressHistory from "./ViewAddressHistory";
import GettingStarted from "./GettingStarted";

//Buyer
import NewTransaction from "./NewTransaction";
import RegisterBuyer from "./RegisterBuyer";

//Seller
import RegisterSeller from "./RegisterSeller";

//Escrow
import RegisterEscrow from "./RegisterEscrow";

render((
  <Router history={browserHistory}>
    <Route path="/" component={App}>
	    <IndexRoute component={Home}/>
      
      <Route path="/GettingStarted" component={GettingStarted}/>
      <Route path="/buyer" component={Buyer}>
        <Route path="/buyer/NewTransaction" component={NewTransaction}/>

        
        <Route path="/buyer/RegisterBuyer" component={RegisterBuyer}/>
      </Route>
        
      <Route path="/seller" component={Seller}>

        <Route path="/seller/RegisterSeller" component={RegisterSeller}/>
      </Route>
      <Route path="/escrow" component={Escrow}>
       
        <Route path="/escrow/RegisterEscrow" component={RegisterEscrow}/>
      </Route>
      <Route path="/help" component={Help}/>
      <Route path="/search" component={Search}/>
      
     
      
	  
       
    </Route>
  </Router>
), document.getElementById('root'));

/*ReactDOM.render(
  <App />,
  document.getElementById('root')
);
*/


// WEBPACK FOOTER //
// ./src/index.js